import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AvatarValue, CheckValue, DateRangeValue, FilterComponent, InputNumberValue, NumberRangeValue, OperatorValue, ProduitActionValue, SelectValue, TagValue } from './filter/filter.component';
import { BadgeFilterComponent } from './badge/badge-filter.component';
import { AvatarSearchModule } from '../avatar-search';
import { DateModule } from '../date';
import { TagModule } from '../tag';
import { ProduitActionModule } from '../produit-action/produit-action.module';
import { NumberRangeComponent } from './filter-input/number-range/number-range.component';

@NgModule({
  declarations: [
    FilterComponent,
    BadgeFilterComponent,
    AvatarValue,
    SelectValue,
    DateRangeValue,
    InputNumberValue,
    CheckValue,
    OperatorValue,
    ProduitActionValue,
    NumberRangeValue,
    NumberRangeComponent,
    TagValue,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    AvatarSearchModule,
    DateModule,
    TagModule,
    ProduitActionModule,
  ],
  exports: [
    FilterComponent,
    BadgeFilterComponent,
    ProduitActionModule,
  ]
})

export class FilterModule { }


